import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Orders from "@/pages/Orders";
import OrderNew from "@/pages/OrderNew";
import OrderDetail from "@/pages/OrderDetail";
// DeviceDetail.jsx quedó huérfano tras unificar el flujo de reparación por equipo en OrderDetail.
// Se mantiene el archivo para permitir un rollback rápido; se eliminará en una limpieza posterior.
import Scanner from "@/pages/Scanner";
import QrRedirect from "@/pages/QrRedirect";
import Customers from "@/pages/Customers";
import AdminUsers from "@/pages/admin/Users";
import AdminRoles from "@/pages/admin/Roles";
import AdminBranches from "@/pages/admin/Branches";
import AdminCategories from "@/pages/admin/Categories";
import AdminServices from "@/pages/admin/Services";
import AdminCosts from "@/pages/admin/Costs";
import AdminSettings from "@/pages/admin/Settings";
import AdminReports from "@/pages/admin/Reports";
import AdminGoals from "@/pages/admin/Goals";
import AdminRegularize from "@/pages/admin/Regularize";
import MyGoals from "@/pages/MyGoals";
import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors closeButton />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/qr/:token" element={<QrRedirect />} />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout>
                  <Navigate to="/dashboard" replace />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route path="/dashboard" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
          <Route path="/orders" element={<ProtectedRoute><Layout><Orders /></Layout></ProtectedRoute>} />
          <Route path="/orders/new" element={<ProtectedRoute><Layout><OrderNew /></Layout></ProtectedRoute>} />
          <Route path="/orders/:id" element={<ProtectedRoute><Layout><OrderDetail /></Layout></ProtectedRoute>} />
          {/* Multi-equipo: cualquier deviceId reutiliza el flujo completo de OrderDetail scopeado al equipo */}
          <Route path="/orders/:id/devices/:deviceId" element={<ProtectedRoute><Layout><OrderDetail /></Layout></ProtectedRoute>} />
          <Route path="/scanner" element={<ProtectedRoute><Layout><Scanner /></Layout></ProtectedRoute>} />
          <Route path="/customers" element={<ProtectedRoute><Layout><Customers /></Layout></ProtectedRoute>} />

          <Route path="/admin/users" element={<ProtectedRoute roles={["admin"]}><Layout><AdminUsers /></Layout></ProtectedRoute>} />
          <Route path="/admin/roles" element={<ProtectedRoute roles={["admin"]}><Layout><AdminRoles /></Layout></ProtectedRoute>} />
          <Route path="/admin/branches" element={<ProtectedRoute roles={["admin"]}><Layout><AdminBranches /></Layout></ProtectedRoute>} />
          <Route path="/admin/categories" element={<ProtectedRoute roles={["admin"]}><Layout><AdminCategories /></Layout></ProtectedRoute>} />
          <Route path="/admin/services" element={<ProtectedRoute roles={["admin"]}><Layout><AdminServices /></Layout></ProtectedRoute>} />
          <Route path="/admin/costs" element={<ProtectedRoute roles={["admin"]}><Layout><AdminCosts /></Layout></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute roles={["admin"]}><Layout><AdminSettings /></Layout></ProtectedRoute>} />
          <Route path="/admin/reports" element={<ProtectedRoute roles={["admin"]}><Layout><AdminReports /></Layout></ProtectedRoute>} />
          <Route path="/admin/goals" element={<ProtectedRoute roles={["admin"]}><Layout><AdminGoals /></Layout></ProtectedRoute>} />
          <Route path="/admin/regularize" element={<ProtectedRoute roles={["admin"]}><Layout><AdminRegularize /></Layout></ProtectedRoute>} />
          <Route path="/my-goals" element={<ProtectedRoute roles={["technician"]}><Layout><MyGoals /></Layout></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
